import React from 'react';

import { OrderListItem } from './OrderListItem';

export const OrderList = ({ orders, selected, onOrderFocus, routeId }) => {

  return (
    <>
      {orders.map((order) => (
        <OrderListItem
          key={order.id}
          order={order}
          selected={!!order.selected || selected}
          onClick={() => onOrderFocus(order)}
          routeId={routeId}
        />
      ))}
    </>
  );
};
